import { createNamespacedHelpers } from 'vuex';

import { WOW_HONOREE_LISTING_COMPONENT_NAMESPACE } from './settings';

export const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  WOW_HONOREE_LISTING_COMPONENT_NAMESPACE
);
